// import {
//   AUTH,
//   LOGOUT,
//   UPDATE_USER,
//   FETCH_USERS,
//   START_LOADING,
//   END_LOADING,
//   DELETE_USER,
// } from "../actions/constants";

// const authReducer = (
//   state = { authData: null, isLoading: true, users: [] },
//   action
// ) => {
//   switch (action.type) {
//     case AUTH:
//       localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
//       // console.log(action?.data)
//       return { ...state, authData: action?.data };
//     case START_LOADING:
//       return { ...state, isLoading: true };
//     case END_LOADING:
//       return { ...state, isLoading: false };
//     case FETCH_USERS:
//       return {
//         ...state,
//         users: action.payload,
//       };
//     case LOGOUT:
//       localStorage.removeItem("profile");
//       return { ...state, authData: null };

//     // case UPDATE_USER:
//     //   return {
//     //     ...state,
//     //     users: state.users.map((user) =>
//     //       user._id === action.payload._id ? action.payload : user
//     //     ),
//     //   };

//     case "UPDATE_USER": // Should be "UPDATE" if standard
//       return {
//         ...state,
//         users: state.users.map((u) =>
//           u._id === action.payload._id ? action.payload : u
//         ),
//       };

//     // case UPDATE_USER:
//     //   // return {...state, users: state.users.map((user) => (user._id === action.payload._id ? action.payload : user))}
//     //   // localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
//     //   //  console.log(action?.data)
//     //   return { users: state.users.map((user) => (user._id === action.payload._id ? action.payload : user))};
//     case DELETE_USER:
//       return {
//         ...state,
//         users: state.users.filter((user) => user._id !== action.payload),
//       };

//     default:
//       return state;
//   }
// };

// export default authReducer;

//----------------------------------------------------------------

import {
  AUTH,
  LOGOUT,
  UPDATE_USER,
  FETCH_USERS,
  START_LOADING,
  END_LOADING,
  DELETE_USER,
  CREATE_USER,
  FETCH_USER_TYPES,
  CREATE_USER_TYPE,
  UPDATE_USER_TYPE,
  DELETE_USER_TYPE,
} from "../actions/constants";
import { clearIdleState } from "../components/IdleSession/idleSessionStore";

const authReducer = (
  state = { authData: null, isLoading: true, users: [], userTypes: [] },
  action
) => {
  switch (action.type) {
    case AUTH:
      localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
      // Company settings are now fetched fresh from the server via useCompany()
      // so we no longer pollute localStorage with store/company settings.
      localStorage.removeItem("profileDetail");
      // A fresh sign-in starts a fresh idle clock - a 401 redirect only
      // removes "profile", so an old session's idle-lock keys could
      // otherwise lock or log out the new session straight away.
      clearIdleState();
      return { ...state, authData: action?.data };
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_USERS:
      return { ...state, users: action.payload };
    case LOGOUT:
      localStorage.clear();
      // sessionVersion exists purely so logging out is *observable*. authData
      // is already null for any session that has been refreshed since login
      // (the store isn't rehydrated from localStorage on boot - see App.js),
      // so `authData: null` would be a null -> null no-op, react-redux would
      // bail out of re-rendering, and App would keep rendering the logged-in
      // tree against a localStorage that has just been cleared. That is the
      // intermittent "logout freezes" case: it only happened when you'd
      // reloaded the page at some point before logging out.
      return { ...state, authData: null, sessionVersion: (state.sessionVersion || 0) + 1 };
    case CREATE_USER:
      return { ...state, users: [action.payload, ...state.users] };
    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((u) => (u._id === action.payload._id ? action.payload : u)),
      };
    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user._id !== action.payload),
      };
    case FETCH_USER_TYPES:
      return { ...state, userTypes: action.payload || [] }; // Fallback to empty array if payload is undefined
    case CREATE_USER_TYPE:
      return { ...state, userTypes: [...state.userTypes, action.payload] };
    case UPDATE_USER_TYPE:
      return {
        ...state,
        userTypes: state.userTypes.map((ut) => (ut.name === action.payload.name ? action.payload : ut)),
      };
    case DELETE_USER_TYPE:
      return {
        ...state,
        userTypes: state.userTypes.filter((ut) => ut.name !== action.payload),
      };

      
    default:
      return state;
  }
};

export default authReducer;